"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addBaseWidgets = void 0;
var AdditionalDetailsPriceOutputWidget_1 = require("./AdditionalDetailsPriceOutputWidget");
var AddressLookupWidget_1 = require("./AddressLookupWidget");
var AddressViewWidget_1 = require("./AddressViewWidget");
var CancellationHeadsUpWidget_1 = require("./CancellationHeadsUpWidget");
var CancellationNoticeWidget_1 = require("./CancellationNoticeWidget");
var CancellationSuccessOutputWidget_1 = require("./CancellationSuccessOutputWidget");
var ClaimsPolarAnswerWidget_1 = require("./ClaimsPolarAnswerWidget");
var CustomDatePickerWidget_1 = require("./CustomDatePickerWidget");
var CustomDateWidget_1 = require("./CustomDateWidget");
var CustomerCancellationReasonWidget_1 = require("./CustomerCancellationReasonWidget");
var CustomerSurveyFormWidget_1 = require("./CustomerSurveyFormWidget");
var CustomMonthWidget_1 = require("./CustomMonthWidget");
var CustomPageValidationWidget_1 = require("./CustomPageValidationWidget");
var CustomPolarAnswerWithNavigateButtonsWidget_1 = require("./CustomPolarAnswerWithNavigateButtonsWidget");
var CustomPolarAnswerWidget_1 = require("./CustomPolarAnswerWidget");
var DocumentsOutputWidget_1 = require("./DocumentsOutputWidget");
var DocumentsReceivalPreferenceQuestionWidget_1 = require("./DocumentsReceivalPreferenceQuestionWidget");
var FalconAutoCompleteQuestionWidget_1 = require("./FalconAutoCompleteQuestionWidget");
var FalconCheckboxWidget_1 = require("./FalconCheckboxWidget");
var FalconCustomRadioWidget_1 = require("./FalconCustomRadioWidget");
var FalconDynamicalAutoCompleteQuestionWidget_1 = require("./FalconDynamicalAutoCompleteQuestionWidget");
var FalconMultipleCheckboxWidget_1 = require("./FalconMultipleCheckboxWidget");
var FieldValidationWidget_1 = require("./FieldValidationWidget");
var InteractionFieldOutputWidget_1 = require("./InteractionFieldOutputWidget");
var InteractionFieldValidationAlertWidget_1 = require("./InteractionFieldValidationAlertWidget");
var InvalidNamePageValidatonWidget_1 = require("./InvalidNamePageValidatonWidget");
var MarketingPreferencesOutputWidget_1 = require("./MarketingPreferencesOutputWidget");
var ModalWidget_1 = require("./ModalWidget");
var PageValidationWidget_1 = require("./PageValidationWidget");
var PanelRoundTopWidget_1 = require("./PanelRoundTopWidget");
var PersonalInfoOutputWidget_1 = require("./PersonalInfoOutputWidget");
var QuoteRefNumOutputWidget_1 = require("./QuoteRefNumOutputWidget");
var SimplifiedCustomDatePickerWidget_1 = require("./SimplifiedCustomDatePickerWidget");
var StickyPriceWidget_1 = require("./StickyPriceWidget");
var SuccessModalWidget_1 = require("./SuccessModalWidget");
var DeclineTextOutputWidget_1 = require("./declineTextOutputWidget/DeclineTextOutputWidget");
var InfoRadioQuestionWidget_1 = require("./infoQuestionWidgets/InfoRadioQuestionWidget");
var InfoDropDownBoxQuestionWidget_1 = require("./infoQuestionWidgets/InfoDropDownBoxQuestionWidget");
var DelayedOverlayWidget_1 = require("./DelayedOverlayWidget");
var CollapsibleQuestionWidget_1 = require("./CollapsibleQuestionWidget");
var InfoMultipleCheckboxQuestionWidget_1 = require("./InfoMultipleCheckboxQuestionWidget");
var CustomDatePickerWithExpiryDateWidget_1 = require("./CustomDatePickerWithExpiryDateWidget");
var FalconRadioWithIdWidget_1 = require("./FalconRadioWithIdWidget");
var UnansweredQuestionsWarningWidget_1 = require("./UnansweredQuestionsWarningWidget");
var FalconNumberInputWidget_1 = require("./FalconNumberInputWidget");
var PolarAnswerWithArrayWidget_1 = require("./infoQuestionWidgets/PolarAnswerWithArrayWidget");
var MtaDeclineTextOutputWidget_1 = require("./declineTextOutputWidget/MtaDeclineTextOutputWidget");
var DocumentListWidget_1 = require("./annual/motor/DocumentListWidget");
var MtaDeclineTextOnLimitExceededWidget_1 = require("./declineTextOutputWidget/MtaDeclineTextOnLimitExceededWidget");
var SupportPortalMTADeclineTextOnLimitExceededWidget_1 = require("./supportPortal/SupportPortalMTADeclineTextOnLimitExceededWidget");
var WrongAnswerInFormBanner_1 = require("./annual/motor/WrongAnswerInFormBanner");
var SupportPortalMTCInfoWidget_1 = require("./supportPortal/SupportPortalMTCInfoWidget");
var StickyWebChatButtonWidget_1 = require("./StickyWebChatButtonWidget");
var ButtonWithValidationWidget_1 = require("./ButtonWithValidationWidget");
var ErrorOutputWidget_1 = require("./ErrorOutputWidget");
var LinkWidget_1 = require("./LinkWidget");
var ClaimsCollectionWidget_1 = require("./ClaimsCollectionWidget");
var addBaseWidgets = function (extensions) {
    extensions.journeyComponents.addQuestionComponent({
        id: "additionalDetailsPriceOutputWidget",
        component: AdditionalDetailsPriceOutputWidget_1.AdditionalDetailsPriceOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "addressLookup",
        component: AddressLookupWidget_1.AddressLookupWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "addressView",
        component: AddressViewWidget_1.AddressViewWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "cancellationHeadsUp",
        component: CancellationHeadsUpWidget_1.CancellationHeadsUpWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "cancellationNotice",
        component: CancellationNoticeWidget_1.CancellationNoticeWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "cancellationSuccessOutput",
        component: CancellationSuccessOutputWidget_1.CancellationSuccessOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "claimsPolarAnswer",
        component: ClaimsPolarAnswerWidget_1.ClaimsPolarAnswerWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "customDatePicker",
        component: CustomDatePickerWidget_1.CustomDatePickerWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "customDatePickerWithExpiryDate",
        component: CustomDatePickerWithExpiryDateWidget_1.default
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "customDate",
        component: CustomDateWidget_1.CustomDateWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "customerCancellationReasons",
        component: CustomerCancellationReasonWidget_1.CustomerCancellationReasonWidget,
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "customerSurveyForm",
        component: CustomerSurveyFormWidget_1.CustomerSurveyFormWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "customMonth",
        component: CustomMonthWidget_1.CustomMonthWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "customPageValidation",
        component: CustomPageValidationWidget_1.CustomPageValidationWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "customPolarAnswer",
        component: CustomPolarAnswerWithNavigateButtonsWidget_1.CustomPolarAnswerWithNavigateButtonsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "customPolarAnswerWithoutNavigation",
        component: CustomPolarAnswerWidget_1.CustomPolarAnswerWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "documentsOutput",
        component: DocumentsOutputWidget_1.DocumentsOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "documentsOutputModal",
        component: DocumentListWidget_1.DocumentListWidget,
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "documentsReceivalPreferenceQuestion",
        component: DocumentsReceivalPreferenceQuestionWidget_1.DocumentsReceivalPreferenceQuestionWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "autoCompleteBox",
        component: FalconAutoCompleteQuestionWidget_1.FalconAutoCompleteQuestionWidget,
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "falconCheckboxWidget",
        component: FalconCheckboxWidget_1.FalconCheckboxWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "falconRadio",
        component: FalconCustomRadioWidget_1.FalconCustomRadioWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "radioWithId",
        component: FalconRadioWithIdWidget_1.FalconRadioWithIdWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "autoCompleteBoxWithDynamicList",
        component: FalconDynamicalAutoCompleteQuestionWidget_1.FalconDynamicalAutoCompleteQuestionWidget,
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "falconMultipleCheckboxWidget",
        component: FalconMultipleCheckboxWidget_1.FalconMultipleCheckboxWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "fieldValidation",
        component: FieldValidationWidget_1.FieldValidationWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "interactionFieldOutput",
        component: InteractionFieldOutputWidget_1.InteractionFieldOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "interactionFieldValidationAlert",
        component: InteractionFieldValidationAlertWidget_1.InteractionFieldValidationAlertWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "invalidNamePageValidation",
        component: InvalidNamePageValidatonWidget_1.InvalidNamePageValidationWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "marketingPreferencesOutput",
        component: MarketingPreferencesOutputWidget_1.MarketingPreferencesOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "modal",
        component: ModalWidget_1.ModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "pageValidation",
        component: PageValidationWidget_1.PageValidationWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "unansweredQuestionsWarning",
        component: UnansweredQuestionsWarningWidget_1.UnansweredQuestionsWarningWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "panelRoundTop",
        component: PanelRoundTopWidget_1.PanelRoundTopWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "personalInfoOutputWidget",
        component: PersonalInfoOutputWidget_1.PersonalInfoOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "quoteRefNumOutput",
        component: QuoteRefNumOutputWidget_1.QuoteRefNumOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "supportPortalCustomDatePicker",
        component: SimplifiedCustomDatePickerWidget_1.SimplifiedCustomDatePickerWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "stickyWebChatButton",
        component: StickyWebChatButtonWidget_1.StickyWebChatButtonWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "stickyPrice",
        component: StickyPriceWidget_1.StickyPriceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "successModal",
        component: SuccessModalWidget_1.SuccessModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "declineTextOutput",
        component: DeclineTextOutputWidget_1.DeclineTextOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "mtaDeclineTextOutput",
        component: MtaDeclineTextOutputWidget_1.MtaDeclineTextOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "mtaDeclineTextOnLimitExceeded",
        component: MtaDeclineTextOnLimitExceededWidget_1.MtaDeclineTextOnLimitExceededWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "supportPortalMtaDeclineTextOnLimitExceeded",
        component: SupportPortalMTADeclineTextOnLimitExceededWidget_1.SupportPortalMtaDeclineTextOnLimitExceededWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "supportPortalMTCInfoDisplay",
        component: SupportPortalMTCInfoWidget_1.SupportPortalMTCInfoWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "infoRadio",
        component: InfoRadioQuestionWidget_1.InfoRadioQuestionWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "polarAnswerWithArray",
        component: PolarAnswerWithArrayWidget_1.PolarAnswerWithArrayWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "infoDropDownBox",
        component: InfoDropDownBoxQuestionWidget_1.InfoDropDownBoxQuestionWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "delayedOverlay",
        component: DelayedOverlayWidget_1.DelayedOverlayWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "infoMultipleCheckbox",
        component: InfoMultipleCheckboxQuestionWidget_1.InfoMultipleCheckboxQuestionWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "collapsibleQuestionWidget",
        component: CollapsibleQuestionWidget_1.CollapsibleQuestionWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "falconNumberInput",
        component: FalconNumberInputWidget_1.FalconNumberInputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "wrongAnswerInFormBanner",
        component: WrongAnswerInFormBanner_1.WrongAnswerInFormBanner
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "buttonWithValidation",
        component: ButtonWithValidationWidget_1.ButtonWithValidationWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "errorOutputWidget",
        component: ErrorOutputWidget_1.ErrorOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "linkWidget",
        component: LinkWidget_1.LinkWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "claimsCollection",
        component: ClaimsCollectionWidget_1.ClaimsCollectionWidget,
    });
};
exports.addBaseWidgets = addBaseWidgets;
//# sourceMappingURL=index.js.map